export default {"src":"/_next/static/media/residential8.586725fa.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};